/**
 *
 * ChangePassword
 *
 */
import { RootState } from 'controller/types';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';

import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components/macro';
import { useUserSetupSlice } from 'features/UserSetup/slice';
import { Field, Form, Formik, FormikProps } from 'formik';

import { Input } from 'core/components/Input';
import { Button } from 'core/components/Button';
import * as Yup from 'yup';
import { isRequiredString } from 'core/utils/validationSchemas';
import { SetupLoader } from 'core/components/SetupComponents/SetupLoader';

interface Props {
  action?: string;
  values?: any;
}

const validationSchema = () =>
  Yup.object({
    OLD_PASSWORD: isRequiredString('Old Password is a required field.'),
    NEW_PASSWORD: isRequiredString('New Password is a required field.'),
    CONFIRM_PASSWORD: Yup.string()
      .oneOf([Yup.ref('NEW_PASSWORD'), ''], 'Password must match')
      .required('Confirm Password is required'),
  });

export const ChangePassword = memo((props: Props) => {
  const authData = useAuth();
  const dispatch = useDispatch();
  const { actions } = useUserSetupSlice();
  const state = useSelector((state: RootState) => state.userSetup);
  const [searchParams, setSearchParams] = useSearchParams();
  const [inputType, setInputType] = useState(true);
  const [initialValues, setinitialValues] = React.useState<any>({
    OLD_PASSWORD: '',
    NEW_PASSWORD: '',
    CONFIRM_PASSWORD: '',
  });

  React.useEffect(() => {
    setinitialValues({
      OLD_PASSWORD: '',
      NEW_PASSWORD: '',
      CONFIRM_PASSWORD: '',
    });
  }, []);

  React.useEffect(() => {
    if (state && state?.navigate && searchParams) {
      searchParams.set('action', 'list');
      searchParams.delete('id');
      setSearchParams(searchParams);
      dispatch(actions.setNavigate(false));
    }
  }, [state, searchParams, setSearchParams, dispatch, actions]);

  return !state?.isLoadinguserData ? (
    <Div>
      <Formik
        validationSchema={validationSchema()}
        initialValues={initialValues}
        onSubmit={async (values, { resetForm }) => {
          dispatch(
            actions.createUserSetupStart({
              data: {
                OLD_PASSWORD: values?.OLD_PASSWORD,
                NEW_PASSWORD: values?.NEW_PASSWORD,
                USER_NAME: authData?.USER_NAME,
              },
              action: props.action || 'save',
              URL: 'changePassword',
              message: 'Password Updated !',
            }),
          );
          resetForm();
        }}
      >
        {(formikProps: FormikProps<any>) => (
          <Form>
            <div className="flex justify-center items-center gap-4 w-full">
              <div className="w-full">
                <Field name="OLD_PASSWORD">
                  {({ field, form, meta }) => (
                    <Input
                      type={inputType ? 'password' : 'text'}
                      label="Old Password"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Enter Old Password"
                      name={field.name}
                      onBlur={field.onBlur}
                      error={meta.touched && meta.error}
                      message={meta.touched && meta.error}
                      required
                    />
                  )}
                </Field>
                <Field name="NEW_PASSWORD">
                  {({ field, form, meta }) => (
                    <Input
                      type={inputType ? 'password' : 'text'}
                      label="New Password"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Enter New Password"
                      name={field.name}
                      onBlur={field.onBlur}
                      error={meta.touched && meta.error}
                      message={meta.touched && meta.error}
                      required
                    />
                  )}
                </Field>
                <Field name="CONFIRM_PASSWORD">
                  {({ field, form, meta }) => (
                    <Input
                      type={inputType ? 'password' : 'text'}
                      label="Confirm Password"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Enter Confirm Password"
                      name={field.name}
                      onBlur={field.onBlur}
                      error={meta.touched && meta.error}
                      message={meta.touched && meta.error}
                      required
                    />
                  )}
                </Field>
                <div className="mt-4 flex gap-2">
                  <Button
                    isPreviousYearCheckNotRequied={true}
                    submit
                    type="primary"
                    label={'Change'}
                  />
                  <Button
                    button={true}
                    onClick={() => setInputType(inputType => !inputType)}
                    type="outlined"
                    label={inputType ? 'Show Password' : 'Hide Password'}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Div>
  ) : (
    <SetupLoader />
  );
});

const Div = styled.div``; 